/* Isotópica theme — light interactivity. Vanilla JS, no dependencies. */
(function () {
  "use strict";

  /* ── Mobile drawer ─────────────────────────────────────────────── */
  function initDrawer() {
    var openBtn = document.querySelector("[data-drawer-open]");
    var drawer = document.querySelector("[data-drawer]");
    var overlay = document.querySelector("[data-drawer-overlay]");
    if (!openBtn || !drawer) return;
    var toggle = function (open) {
      drawer.dataset.open = open;
      if (overlay) overlay.dataset.open = open;
      document.body.style.overflow = open ? "hidden" : "";
    };
    openBtn.addEventListener("click", function () { toggle(true); });
    if (overlay) overlay.addEventListener("click", function () { toggle(false); });
    drawer.querySelectorAll("[data-drawer-close]").forEach(function (el) {
      el.addEventListener("click", function () { toggle(false); });
    });
  }

  /* ── Product gallery ───────────────────────────────────────────── */
  function initGallery() {
    document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
      var track = gallery.querySelector("[data-gallery-track]");
      var counter = gallery.querySelector("[data-gallery-counter]");
      var thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
      if (!track) return;
      var slides = track.children;
      var setActive = function (i) {
        if (counter) counter.textContent = (i + 1) + "/" + slides.length;
        thumbs.forEach(function (t, ti) { t.setAttribute("aria-current", ti === i ? "true" : "false"); });
      };
      track.addEventListener("scroll", function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        setActive(i);
      }, { passive: true });
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener("click", function () {
          track.scrollTo({ left: i * track.clientWidth, behavior: "smooth" });
          setActive(i);
        });
      });
      setActive(0);
    });
  }

  /* ── Variant selection (radio pills) ───────────────────────────── */
  function initVariants() {
    document.querySelectorAll("[data-product-form]").forEach(function (form) {
      var idInput = form.querySelector("[data-variant-id]");
      var pills = form.querySelectorAll("[data-variant]");
      var priceEls = document.querySelectorAll('[data-price-for="' + form.dataset.productForm + '"]');
      if (!pills.length) return;
      var select = function (pill) {
        pills.forEach(function (p) { p.setAttribute("aria-checked", p === pill ? "true" : "false"); });
        if (idInput) idInput.value = pill.dataset.variant;
        var price = pill.dataset.price;
        priceEls.forEach(function (el) { if (price) el.textContent = price; });
      };
      pills.forEach(function (pill) {
        pill.addEventListener("click", function () { select(pill); });
      });
    });
  }

  /* ── Add to cart (AJAX) ────────────────────────────────────────── */
  function initAddToCart() {
    document.querySelectorAll("[data-product-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = form.querySelector("[data-add-btn]");
        var idInput = form.querySelector("[data-variant-id]");
        if (!idInput || !idInput.value) return;
        if (btn) btn.disabled = true;
        fetch(window.ISOTOPICA.routes.cart_add, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            form.setAttribute("data-added", "true");
            document.querySelectorAll("[data-sticky-cta]").forEach(function (s) { s.setAttribute("data-added", "true"); });
            updateCartCount();
          })
          .finally(function () { if (btn) btn.disabled = false; });
      });
    });
  }

  function updateCartCount() {
    fetch(window.ISOTOPICA.routes.cart + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  /* ── Sticky mobile CTA ─────────────────────────────────────────── */
  function initStickyCta() {
    var cta = document.querySelector("[data-sticky-cta]");
    var hero = document.getElementById("pdp-hero");
    if (!cta || !hero) return;
    var check = function () {
      cta.setAttribute("data-show", hero.getBoundingClientRect().bottom <= 80 ? "true" : "false");
    };
    var raf = 0;
    window.addEventListener("scroll", function () {
      if (!raf) raf = requestAnimationFrame(function () { raf = 0; check(); });
    }, { passive: true });
    check();
  }

  document.addEventListener("DOMContentLoaded", function () {
    initDrawer();
    initGallery();
    initVariants();
    initAddToCart();
    initStickyCta();
  });
})();
